import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { getCardById } from '../use';

const { registerReducer } = useStorymapStore();

export class AllCardInsightsUnlinked extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'AllCardInsightsUnlinked';

    public constructor(public cardId: string) {
        super(AllCardInsightsUnlinked.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: AllCardInsightsUnlinked): void => {
    const card = getCardById(action.cardId);
    card.hasFeedback = false;
};

//@ts-ignore
registerReducer(AllCardInsightsUnlinked.ACTION_TYPE, reducer);